import React from 'react';
import { Music } from 'lucide-react';
import { type MusicTrack } from '@/services/musicTracksService';
import { TrackRow } from './TrackRow';

interface TracksListProps {
  tracks: MusicTrack[];
  onRefresh?: () => void;
  canEdit?: boolean;
  selectedTrackId?: string | null;
  onTrackSelect?: (track: MusicTrack | null) => void;
  activePlayerStoragePath?: string | null;
  onPlayStart?: (storagePath: string) => void;
}

export function TracksList({
  tracks,
  onRefresh,
  canEdit = false,
  selectedTrackId = null,
  onTrackSelect,
  activePlayerStoragePath = null,
  onPlayStart,
}: TracksListProps) {
  if (tracks.length === 0) {
    return (
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center text-center text-muted-foreground py-12">
        <Music className="h-16 w-16 mb-4 opacity-50" />
        <p className="text-lg font-medium mb-2">No tracks yet</p>
        <p className="text-sm">Add your first track using the Add Track button</p>
      </div>
    );
  }

  return (
    <div className="min-h-0 flex-1 overflow-auto">
      <div className="divide-y divide-border">
        {tracks.map((track) => (
          <TrackRow
            key={track.id}
            track={track}
            isSelected={track.id === selectedTrackId}
            onSelect={() => onTrackSelect?.(track)}
            activePlayerStoragePath={activePlayerStoragePath}
            onPlayStart={onPlayStart ? () => onPlayStart(track.storagePath) : undefined}
          />
        ))}
      </div>
    </div>
  );
}
